import { HOST } from "../../settings/setting";
import { authFecth } from "../../helpers/authFecth";
import Actions from "../consts";

export const loadSpanishCourse = () => async (dispatch: any, getState: any) => {
  const { course, application } = getState();
  if (
    application.currentLanguage !== "es" || !course.data?.id ||
    !["idle", "error"].includes(course.spanishContentStatus)
  ) return;

  const generation = course.translationGeneration;
  dispatch({ type: Actions.LOAD_SPANISH_COURSE, generation });
  try {
    const response: any = await authFecth(`${HOST}/api/course/spanish`, "get");
    // The API's legacy error wrapper may return an error body with HTTP 200.
    if (
      response?.language !== "es" ||
      typeof response.available !== "boolean" ||
      (response.available && (
        response.course_data?.type !== "course" ||
        !Array.isArray(response.course_data?.children) ||
        response.course_data?.id !== course.data.id ||
        response.course_data?.version !== course.data.version
      ))
    ) throw new Error("Invalid Spanish course response");

    dispatch({
      type: Actions.RECEIVE_SPANISH_COURSE,
      generation,
      payload: response.available ? response.course_data : null,
    });
  } catch {
    // Keep the session usable in English. Switching back to Spanish retries.
    dispatch({ type: Actions.SPANISH_COURSE_FAILED, generation });
  }
};
